import { render } from "./ReferenceOverlay.vue?vue&type=template&id=498f88ab&scoped=true"
import script from "./ReferenceOverlay.vue?vue&type=script&lang=js"
export * from "./ReferenceOverlay.vue?vue&type=script&lang=js"

import "./ReferenceOverlay.vue?vue&type=style&index=0&id=498f88ab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-498f88ab"

export default script